import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "../../../components/Footer";
import img1 from "../../../assets/images/banner-post3.jpg";
import premioImg2 from "../../../assets/images/news/post2-1.JPG";

import { Container, Main, Post } from "./styles";

function SingleNew6() {
  return (
    <>
      <div id="projects">
        <Container>
          <header>
            <div className="back">
              <Link to="/news">
                <FaArrowLeft /> Voltar
              </Link>
            </div>

            <span>Notícias</span>
          </header>
        </Container>
        <Main>
          <Container>
            <div class="posts">
              <Post>

                <section>
                  <div className="banner">
                    <img src={premioImg2} />
                  </div>
                  <div className="content">
                    <h2>MELHOR COLABORADOR DO ANO 2020</h2>

                    <p>
                      <strong>Dr Gonçalo Santos</strong> eleito como melhor
                      colaborador do ano de 2020 na Skyland.
                    </p>

                    <p>
                      Valorizamos a excelência na industria imobiliária, portanto
                      não poderiamos deixar de reconhecer aqueles que fazem o
                      nosso trabalho possível com empenho e dedicação.
                    </p>

                    <p>
                      <strong>Fonte: Skyland</strong>
                    </p>

                    <br />
                  </div>
                </section>
              </Post>
            </div>
          </Container>
        </Main>
      </div>
      <Footer />
    </>
  );
}

export default SingleNew6;
